// extracted by mini-css-extract-plugin
export default {"DailyModal":"DailyModal_DailyModal__EL4jA","modalContent":"DailyModal_modalContent__TJ9zX","days":"DailyModal_days__cKK2K"};